import styled from "styled-components";
import { colours } from "../../styles/colours.constants";

export const ProgressBar = styled.div`
	position: relative;
	width: 100%;
`;

export const Track = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	background-color: ${colours.greyMedium};
	width: 100%;
	height: 6px;
`;

type ProgressStyleProps = {
	$width: string;
};

export const Progress = styled.div<ProgressStyleProps>`
	width: ${({ $width }) => $width};
	height: 6px;
	background-color: ${colours.red};
	position: absolute;
	left: 0;
	top: 0;
`;
